import React, {useState} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {connect} from 'react-redux';
import {Popover, Tag} from "antd";
import {LocaleText, QTable} from "ui";
import moment from "moment";
import GradingModal from "components/Grading/GradingModal";
import DeleteTaskMenuItem from "components/Grading/DeleteTaskMenuItem";
import { Filter } from 'components/Modals';
import { gradingFilterModules } from 'components/Grading/gradingFilterModules';
import { AbsenceTag } from 'components/Tags';

const mapStateToProps = (state: any) => {
    return {
        session: state.session,
    };
};

const PendingGrading: React.FC<any> = () => {
    const [visibleTooltip, setVisibleTooltip] = useState<any>();
    const [reload, setReload] = useState(false);
    const [selectedAttemptData, setSelectedAttemptData] = useState<any>(null);
    const [filters, setFilters] = useState<Record<string, any>>({});

    const intl = useIntl();

    const columns = [
        {
            title: intl.formatMessage({id: 'courses.assignment_title'}),
            key: 'title',
            dataIndex: 'title',
        },
        {
            title: intl.formatMessage({id: 'general.learning_programs'}),
            key: 'programTitle',
            render: (value: string, record: any) => {
                return <LocaleText text={record.programTitle} />   
            }
        },
        {
            title: intl.formatMessage({id: 'general.type'}),
            key: 'type',
            dataIndex: 'type',
        },
        {
            title: intl.formatMessage({id: 'general.student'}),
            key: 'studentName',
            dataIndex: 'studentName',
        },
        {
            title: intl.formatMessage({id: 'general.email'}),
            key: 'studentEmail',
            dataIndex: 'studentEmail',
        },
        {
            title: intl.formatMessage({id: 'general.organization'}),
            key: 'organization',
            dataIndex: 'organization',
        },
        {
            title: intl.formatMessage({id: 'courses.submission_date'}),
            key: 'submissionDate',
            dataIndex: 'submissionDate',
            render: (submissionDate: string) => {
                return submissionDate ? moment(submissionDate).format('DD/MM/YYYY HH:mm:ss') : '-'
            }
        },
        {
            title: intl.formatMessage({id: 'general.status'}),
            key: 'status',
            dataIndex: 'status',
            render: (status: string) => {
                return getStatusTag(status)
            }
        },
        {
            title: intl.formatMessage({ id: 'users.form.long_absence' }),
            dataIndex: 'absence',
            key: 'absence',
            render: (record: null | string) => <AbsenceTag status={!!record}/>
        },
        {
            key: 'actions',
            render: (_: string, record: any, index: number) => {
                const content = (
                    <>
                        <div className='popover-item' onClick={() => {
                            setSelectedAttemptData(record);
                            setVisibleTooltip(null);
                        }}>
                            <FormattedMessage id='grading.grade_assignment'/>
                        </div>
                        <DeleteTaskMenuItem
                            attemptId={record.attemptId}
                            onDone={() => {
                                setVisibleTooltip(null);
                                setReload(true);
                            }}
                        />
                    </>
                );

                return (
                    <Popover
                        open={index === visibleTooltip}
                        content={content}
                        trigger='click'
                        placement='bottomRight'
                        arrowPointAtCenter
                        onOpenChange={(visible) => setVisibleTooltip(visible ? index : null)}
                    >
                        <div style={{width: '100%', cursor: 'pointer', textAlign: 'center'}}>
                            <i className='fal fa-ellipsis-v' style={{fontSize: '16px'}}/>
                        </div>
                    </Popover>
                )
            },
        }
    ];

    const getStatusTag = (status: string) => {
        let color = ''
        let messageId = ''

        switch (status) {
            case 'NOT_STARTED':
                color = 'gold'
                messageId = 'student.not_started'
                break;
            case 'IN_PROGRESS':
                color = 'blue'
                messageId = 'courses.topic_status.pending_grading'
                break;
            case 'FINAL_ASSESSMENT':
                color = 'blue'
                messageId = 'courses.topic_status.final_assessment'
                break;
            case 'SUBMITTED':
                color = 'blue'
                messageId = 'grading.pending_grading'
                break;
            case 'PASSED':
                color = 'green'
                messageId = 'courses.topic_status.passed'
                break;
            case 'FAILED':
                color = 'red'
                messageId = 'courses.topic_status.failed'
                break;
            case 'MISSED_DEADLINE':
                color = 'red'
                messageId = 'courses.topic_status.missed_deadline'
                break;
            case 'RETURNED':
                color = 'red'
                messageId = 'courses.topic_status.submission_returned'
                break;
            default:
                color = 'gold'
                messageId = 'courses.topic_status.not_submitted'
                break;
        }

        return (
            <Tag color={color}>
                <FormattedMessage id={messageId}/>
            </Tag>
        )
    }

    return (
        <>
            <GradingModal
                onCancel={() => {
                    setSelectedAttemptData(null)
                }}
                attemptData={selectedAttemptData}
                onGraded={() => {
                    setSelectedAttemptData(null);
                    setReload(true);
                }}
            />
            <Filter
                setFilter={setFilters}
                modules={gradingFilterModules(filters)}
                resetFields={{acknowledgement_required: ['acknowledged']}}
                submit={() => setReload(true)}
                searchKey='qu'
                hasSearch
            />

            <QTable
                tableKey={'gradingStudents'}
                columns={columns}
                url={`/api/v1/courses/grading/get-gradings/pending`}
                setReload={setReload}
                reload={reload}
                rowSelection={false}
                rowKey={'id'}
                filter={filters}
                scroll={{x: true}}
            />
        </>
    );
};

export default connect(mapStateToProps)(PendingGrading);
